import { useState } from "react";
import "../App.scss";

export default function StoreHeartIcon({
    active = false,
    size = 32,
    onClick,
}) {
    const [animate, setAnimate] = useState(false);

    const handleClick = (e) => {
        setAnimate(true);

        // remove class after animation ends
        setTimeout(() => setAnimate(false), 400);

        onClick?.(e);
    };

    return (
        <button
            type="button"
            aria-label={active ? "Unfollow" : "Follow"}
            className={`heart-btn ${active ? "active" : ""} ${animate ? "animate" : ""}`}
            onClick={handleClick}
        >
            <svg
                width={size}
                height={size}
                viewBox="0 0 24 24"
                className="heart-svg"
                fill={active ? "currentColor" : "none"}
            >
                <path
                    d="m12 21.429-9.461-8.652c-5.11-5.11 2.41-15.02 9.461-7.029
          7.05-7.99 14.572 1.918 9.461 7.029z"
                    stroke="currentColor"
                    strokeWidth="1.6"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </button>
    );
}
